import axios from 'axios';

export default class User {

    static async ChangePassword(token, password) {
        var bodyFormData = new FormData();
        bodyFormData.append('token', token);
        bodyFormData.append('pass', password);
    
        let res = await axios({
            method: 'post',
            url:process.env.VUE_APP_API_ENDPOINT_PROTECTED +'/user/reset-password',
            data: bodyFormData
            });
    
            return res;
      }


}